import styles from './App.module.css';
import Section from './components/Section/Section';
import Button from './components/Button/Button';



import nb01 from './components/Section/Assets/1.png';
import nb02 from './components/Section/Assets/2.png';
import nb03 from './components/Section/Assets/3.png';
import nb04 from './components/Section/Assets/4.png';
import nb05 from './components/Section/Assets/5.png';

import Header from './components/Header/Header';
import S01 from './components/Content/S01';
import S02 from './components/Content/S02';
import S03 from './components/Content/S03';
import S04 from './components/Content/S04';
import S05 from './components/Content/S05';
import Footer from './components/Footer/Footer';



function App() {
  return (
    <div className={styles.app}>

    <Header></Header>

      <Section open={true} numberImg={nb01} bgColor="#2C4B93" darkColor="#1E3775" title={"LESSONS FROM COVID-19 FOR DEMOCRATIC RESILIENCE"} description={"For two years, COVID-19 has been taking lives, disrupting livelihoods and shaking certainties around the world. In democratic countries, it has perturbed the functioning of democratic institutions, posed unprecedented challenges for policy delivery, and tested leaders, citizens and institutions’ commitment to democratic values and principles. How can democracies prepare to offer a more effective and more democratic response to future emergencies?<br/><br/>Throughout 2021, the Global Commission on Democracy and Emergencies brought together 16 eminent political and civil society leaders to answer this question, drawing on lessons from the global mosaic of democratic experiences during COVID-19."}>
        <S01/>

      </Section>
      <Section open={false} numberImg={nb02} bgColor="#5A0B20" darkColor="#360713" title={"METHODOLOGY"} description={"Drawing lessons from COVID-19 to enhance the resilience of democratic systems is an enormous task. Political scientists and experts around the world have been collecting data, producing analyses and putting forward recommendations for the past two years. The Global Commission on Democracy and Emergencies had the mandate to integrate their thoughts into a single effort, across thematic silos, geographies and communities of practice. "}>
        <S02/>
      </Section>
      <Section open={false} numberImg={nb03} bgColor="#248954" darkColor="#397254" title={"MEET THE COMMISSIONERS"} description={"The Global Commission on Democracy and Emergencies was formed by 16 Commissioners: democratic former Heads of State or Government and current leaders from international and civil society organizations, academia and media. The Commissioners participated in work sessions, deliberations, and regional consultations over the course of nine months to identify good practices and lessons learned, drawing on the experience of COVID-19 in democracies around the world."}>
        <S03/>

      </Section>
      <Section open={false} numberImg={nb04} bgColor="#C66A26" darkColor="#B16021" title={"CLUB DE MADRID"} description={"The Global Commission put forward its 20 recommendations thanks to Club de Madrid Members’ unique and collective experience, as well as the expertise of over 30 academic researchers, civil society leaders, business representatives and senior policy-makers from around the democratic world.<br/><br/>Club de Madrid is now bringing these recommendations to government officials, parliamentarians, judicial experts, civil society leaders and all engaged citizens to lay the basis for a more democratic response to current and future emergencies."}>
        <S04/>

      </Section>
      <Section open={false} numberImg={nb05} bgColor="#EDAA03" darkColor="#D19500" title={"PARTNERS"} description={"Throughout its mandate, the Global Commission counted on the financial support from the ACS Foundation and the valuable contribution of International IDEA, Oxfam, and Edelman as the knowledge partners that helped guide the Global Commission's reflections by providing data, analysis, and essential frameworks for its recommendations."}>
        <S05/>

      </Section>
      <Footer/>
    </div>
  );
}

export default App;
